// extracted by mini-css-extract-plugin
export default {"WorkLeft":"workLeft_WorkLeft__X87Bb"};